import { FC, SVGAttributes } from 'react';

const Pin: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.9982 21.9124C12.7803 21.9124 13.4143 21.2783 13.4143 20.4962C13.4143 19.7141 12.7803 19.0801 11.9982 19.0801C11.2161 19.0801 10.582 19.7141 10.582 20.4962C10.582 21.2783 11.2161 21.9124 11.9982 21.9124Z"
                stroke="currentColor"
                strokeWidth="1.45"
                strokeMiterlimit="10"
            />
            <path
                d="M11.9982 16.2483C12.7803 16.2483 13.4143 15.6143 13.4143 14.8322C13.4143 14.05 12.7803 13.416 11.9982 13.416C11.2161 13.416 10.582 14.05 10.582 14.8322C10.582 15.6143 11.2161 16.2483 11.9982 16.2483Z"
                stroke="currentColor"
                strokeWidth="1.45"
                strokeMiterlimit="10"
            />
            <path
                d="M13.4143 9.1681C13.4143 9.44819 13.3313 9.72199 13.1757 9.95487C13.0201 10.1878 12.7989 10.3693 12.5401 10.4765C12.2814 10.5836 11.9966 10.6117 11.7219 10.557C11.4472 10.5024 11.1949 10.3675 10.9968 10.1695C10.7988 9.97142 10.6639 9.71909 10.6092 9.44438C10.5546 9.16967 10.5826 8.88493 10.6898 8.62617C10.797 8.3674 10.9785 8.14623 11.2114 7.99062C11.4443 7.83501 11.7181 7.75195 11.9982 7.75195C12.3738 7.75195 12.734 7.90115 12.9995 8.16673C13.2651 8.43231 13.4143 8.79252 13.4143 9.1681Z"
                stroke="currentColor"
                strokeWidth="1.45"
                strokeMiterlimit="10"
            />
            <path
                d="M11.9982 4.92019C12.7803 4.92019 13.4143 4.28616 13.4143 3.50404C13.4143 2.72192 12.7803 2.08789 11.9982 2.08789C11.2161 2.08789 10.582 2.72192 10.582 3.50404C10.582 4.28616 11.2161 4.92019 11.9982 4.92019Z"
                stroke="currentColor"
                strokeWidth="1.45"
                strokeMiterlimit="10"
            />
            <path
                d="M17.6661 16.2483C18.4483 16.2483 19.0823 15.6143 19.0823 14.8322C19.0823 14.05 18.4483 13.416 17.6661 13.416C16.884 13.416 16.25 14.05 16.25 14.8322C16.25 15.6143 16.884 16.2483 17.6661 16.2483Z"
                stroke="currentColor"
                strokeWidth="1.45"
                strokeMiterlimit="10"
            />
            <path
                d="M17.6661 10.5843C18.4483 10.5843 19.0823 9.95022 19.0823 9.1681C19.0823 8.38598 18.4483 7.75195 17.6661 7.75195C16.884 7.75195 16.25 8.38598 16.25 9.1681C16.25 9.95022 16.884 10.5843 17.6661 10.5843Z"
                stroke="currentColor"
                strokeWidth="1.45"
                strokeMiterlimit="10"
            />
            <path
                d="M17.6661 4.92019C18.4483 4.92019 19.0823 4.28616 19.0823 3.50404C19.0823 2.72192 18.4483 2.08789 17.6661 2.08789C16.884 2.08789 16.25 2.72192 16.25 3.50404C16.25 4.28616 16.884 4.92019 17.6661 4.92019Z"
                stroke="currentColor"
                strokeWidth="1.45"
                strokeMiterlimit="10"
            />
            <path
                d="M6.33412 16.2483C7.11624 16.2483 7.75027 15.6143 7.75027 14.8322C7.75027 14.05 7.11624 13.416 6.33412 13.416C5.552 13.416 4.91797 14.05 4.91797 14.8322C4.91797 15.6143 5.552 16.2483 6.33412 16.2483Z"
                stroke="currentColor"
                strokeWidth="1.45"
                strokeMiterlimit="10"
            />
            <path
                d="M6.33412 10.5843C7.11624 10.5843 7.75027 9.95022 7.75027 9.1681C7.75027 8.38598 7.11624 7.75195 6.33412 7.75195C5.552 7.75195 4.91797 8.38598 4.91797 9.1681C4.91797 9.95022 5.552 10.5843 6.33412 10.5843Z"
                stroke="currentColor"
                strokeWidth="1.45"
                strokeMiterlimit="10"
            />
            <path
                d="M6.33412 4.92019C7.11624 4.92019 7.75027 4.28616 7.75027 3.50404C7.75027 2.72192 7.11624 2.08789 6.33412 2.08789C5.552 2.08789 4.91797 2.72192 4.91797 3.50404C4.91797 4.28616 5.552 4.92019 6.33412 4.92019Z"
                stroke="currentColor"
                strokeWidth="1.45"
                strokeMiterlimit="10"
            />
        </svg>
    );
};

export default Pin;
